import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const fmtINR = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });

export const fileUrl = (path) => `${API}/files/${path}`;

export const pkgImage = (pkg) =>
  pkg?.image_storage_path ? fileUrl(pkg.image_storage_path) : pkg?.image_url || "";

export const LOGO_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_event-book-12/artifacts/5a2a613ae27166aa_Glossy%20MetrixEvent%20Logo%20on%20Magenta.png";
